module.exports = __webpack_public_path__ + "img/d4.b3b27094.jpg";